module.exports = __webpack_public_path__ + "static/media/DocumentGridBookmark.8431eab3.png";